const ViewType = {
    TABLE: 1,
    CHART: 2,
    PIPELINE: 3
}

export default ViewType;